<template>
  <v-container fluid class="pa-0 ma-0">
    <v-data-table
      dense
      :headers="headers"
      :items="commissions"
      :items-per-page="-1"
      hide-default-footer
    >
      <template v-slot:item.role="{ item }">
        {{item.role | roleLabel}}
      </template>
      <template v-slot:item.commission="{ item }">
        {{item.commission}}%
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'

export default {
  data: () => ({
    headers: [
      {
        text: 'User',
        sortable: true,
        value: 'fullName'
      },
      {
        text: 'Role',
        sortable: true,
        value: 'role'
      },
      {
        text: 'Commission',
        sortable: true,
        value: 'commission'
      }
    ]
  }),
  computed: {
    ...mapFields('directPlacement', [
      'commissions'
    ])
  }
}
</script>
